<script>
  //import Progress from '~components/progress/Progress.svelte'
  //import { mimeType } from '@beyonk/components/lib/mime-type'
  import { createEventDispatcher, onMount, onDestroy, getContext } from 'svelte';
  const dispatch = createEventDispatcher();
  export let maxFileSize = 3145728;
  export let allowedFileTypes = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
  import { client } from 'root/api/index.js';
  const showDialog = getContext('showDialog');
  export let isDisabled = false;
  import * as FilePond from 'filepond';
  import 'filepond/dist/filepond.min.css';
  import '../assets/css/filepond.css';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
  import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
  import FilePondPluginImageResize from 'filepond-plugin-image-resize';
  import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

  import { fileDownload } from 'components/Helper.js';

  // Import the plugin styles
  import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

  FilePond.registerPlugin(FilePondPluginImageTransform);
  FilePond.registerPlugin(FilePondPluginImagePreview);
  FilePond.registerPlugin(FilePondPluginFilePoster);
  FilePond.registerPlugin(FilePondPluginFileValidateType);
  FilePond.registerPlugin(FilePondPluginFileValidateSize);
  FilePond.registerPlugin(FilePondPluginImageResize);

  let uploader;
  let uploading = false;
  let processing = false;
  let progress = 0;
  export let allowMultiple;
  export let photoUrl;
  export let requestFrom;
  export let entityId = null;

  const getFileName = (url) => {
    return url.split('?')[0].split('/')[4];
  };
  export let allFileType = false;

  let files = [];
  if (photoUrl) {
    if (typeof photoUrl == 'string') {
      files = [
        {
          options: {
            type: 'local',
            file: { name: '', size: null },
            metadata: { poster: photoUrl },
          },
        },
      ];
    } else {
      for (const i in photoUrl) {
        let fileName = '';
        if (allFileType) {
          if (photoUrl[i]['origionalName'] != undefined && photoUrl[i]['origionalName'] != '') {
            fileName = photoUrl[i]['origionalName'];
          } else if (photoUrl[i]['fileName'] != undefined && photoUrl[i]['fileName'] != '') {
            fileName = photoUrl[i]['fileName'];
          }
        }
        files.push({
          options: {
            type: 'local',
            file: {
              name: fileName,
              size: photoUrl[i]['fileSize'] != undefined ? photoUrl[i]['fileSize'] : null,
            },
            metadata: {
              ...photoUrl[i],
              poster: photoUrl[i]['url'],
              posterId: photoUrl[i]['id'],
              downloadUrl: photoUrl[i]['downloadUrl'],
              fileType: photoUrl[i]['fileType'],
            },
          },
        });
      }
    }
  }
  let pond;
  let addedFiles = {};
  let acceptedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'];
  let timeOut = '';
  let request = new AbortController();
  let maxTotalFileSize =
    requestFrom == 'taskEmailAttachment' || requestFrom == 'taskTemplateEmailAttachment'
      ? '10MB'
      : null;
  export const browseFile = () => {
    pond.browse();
  };

  let allowFileTypeValidation = true;
  const signal = request.signal;
  if (allFileType) {
    acceptedTypes = [
      ...acceptedTypes,
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
  }
  onMount(() => {
    pond = FilePond.create(uploader);
    pond.setOptions({
      allowImageResize: allFileType ? false : true,
      imageResizeMode: 'cover',
      imageResizeTargetWidth: 250,
      imageResizeTargetHeight: 250,
      imageResizeUpscale: false,
      allowPaste: false,
      files: files,
      labelFileProcessingComplete: '',
      labelTapToUndo: '',
      labelTapToRetry: '',
      labelTapToCancel: '',
      labelFileProcessing: '',
      allowFilePoster: allFileType ? false : true,
      filePosterMinHeight: 100,
      filePosterMaxHeight: 100,
      filePosterHeight: 100,
      allowImagePreview: allFileType ? false : true,
      imagePreviewMinHeight: 100,
      imagePreviewMaxHeight: 100,
      imagePreviewHeight: 100,
      allowFileTypeValidation: allowFileTypeValidation,
      labelFileTypeNotAllowed: '',
      fileValidateTypeLabelExpectedTypes: 'Invalid File Type',
      allowFileSizeValidation: true,
      disabled: isDisabled,
      labelMaxFileSizeExceeded: allFileType ? 'Image is too large' : 'File is too large',
      labelMaxFileSize: allFileType
        ? 'Maximum file size is {filesize}'
        : 'Maximum image size can be {filesize}',
      maxFileSize: '6MB',
      maxTotalFileSize: maxTotalFileSize,
      labelMaxTotalFileSizeExceeded: '',
      labelMaxTotalFileSize: 'Maximum total file size limit is 10 MB',
      instantUpload: true,
      labelIdle:
        allowMultiple != undefined && allowMultiple
          ? "<div class='file-upload-attachment'>Select from your computer or drag & drop your file here</div>"
          : 'Upload',
      acceptedFileTypes: acceptedTypes,
      onactivatefile: (ifile) => {
        if (ifile.getMetadata().downloadUrl != undefined) {
          const token = localStorage.getItem('token');
          fetch(ifile.getMetadata().downloadUrl, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = ifile.getMetadata().displayName || ifile.filename;
              link.click();
              window.URL.revokeObjectURL(url);
            })
            .catch((err) => {
              showDialog({ message: err.message });
            });
        }
      },
      beforeRemoveFile: (ifile) => {
        let fileData = ifile.getMetadata();
        if (
          fileData != undefined &&
          fileData.taskTemplateId != undefined &&
          fileData.taskTemplateId > 0 &&
          requestFrom != undefined &&
          requestFrom == 'task'
        ) {
          showDialog({
            message: 'You can not delete template attachment',
          });
          return false;
        }
        return true;
      },
      onremovefile: (error, ifile) => {
        let fileName = '';
        let fileId = '';
        if (ifile.filename != '') {
          if (addedFiles[ifile.filename] != undefined) {
            fileName = addedFiles[ifile.filename];
            delete addedFiles[ifile.filename];
          } else {
            if (allFileType && ifile.getMetadata().posterId != undefined) {
              fileName = ifile.getMetadata().poster;
              fileId = ifile.getMetadata().posterId;
            } else {
              fileName = ifile.filename;
            }
          }
        } else {
          fileName = getFileName(ifile.getMetadata().poster);
          if (ifile.getMetadata().posterId != undefined) {
            fileId = ifile.getMetadata().posterId;
          }
        }
        dispatch('fileChanged', { type: 'delete', fileName, fileId });
      },
      onprocessfile: () => {
        if (timeOut != '') {
          clearTimeout(timeOut);
        }
        timeOut = setTimeout(() => {
          dispatch('fileChanged', { type: 'uploaded' });
        }, 2000);
      },
      onprocessfilestart: (error, file) => {
        dispatch('fileChanged', { type: 'uploading' });
      },

      server: {
        revert: null,
        process: function (fieldName, file, metadata, load, error, progress, abort) {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('requestFrom', requestFrom || '');
          if (entityId) {
            formData.append('entityId', entityId);
          }

          client
            .fileUpload(formData)
            .then((result) => {
              if (result.status?.code === 200 && result.data) {
                load('ok');
                dispatch('fileChanged', {
                  type: 'add',
                  fileSize: file.size,
                  displayName: file.name,
                  fileName: result.data.fileName,
                  downloadUrl: result.data.downloadUrl,
                });
                if (requestFrom == 'chat') {
                  pond.removeFile(file);
                } else {
                  addedFiles[file.name] = result.data.fileName;
                }
              } else {
                error('Upload failed');
              }
            })
            .catch(() => {
              error('Upload failed');
            });
          return {
            abort: () => {
              request.abort();
              abort();
            },
          };
        },
      },
    });
  });
  onDestroy(() => {
    if (typeof pond !== 'undefined') {
      pond.destroy();
    }
  });

  function reset() {
    uploading = false;
    processing = false;
    progress = 0;
  }
  function getFileExtension(file) {
    const filenameParts = file.name.split('.');
    return filenameParts[filenameParts.length - 1].toLowerCase();
  }
  function validateUpload(file) {
    if (file.size > maxFileSize) {
      dispatch('error', {
        message: `Maximum file size is ${maxFileSize / (1024 * 1024)}mb`,
      });
      return false;
    }
    if (!allowedFileTypes.includes(getFileExtension(file))) {
      dispatch('error', {
        message: `Allowed file types are ${allowedFileTypes.join(',')}.`,
      });
      return false;
    }
    return true;
  }
  function onError(e) {
    dispatch('error', {
      message: `We were unable to upload your photo, ${e.message}. Please try again.`,
    });
  }
  function onProgress(e) {
    if (e.lengthComputable) {
      progress = Math.round((e.loaded * 100) / e.total);
    }
  }
</script>

{#if allowMultiple}
  <input
    class={allFileType ? 'doc-file-upload' : 'multiple-img'}
    bind:this={uploader}
    type="file"
    multiple
  />
{:else}
  <input
    class="single-file-upload"
    bind:this={uploader}
    type="file"
  />
{/if}
